import { isFunction } from './index.js';
function trigger(fn, ...parameters) {
    return function triggerWrapper() {
        if (isFunction(fn)) {
            return fn(...parameters);
        }
    };
}
export default trigger;
//# sourceMappingURL=trigger.js.map